import {
    USER_UPDATE,
    STORE_RESET
} from '../../actions/action-types';
import appInitialState from '../../store/appInitialState';

const initialState = appInitialState.user;

/**
 * This is the application state's user slice reducer
 *
 * @param {Object} state 
 * @param {Object} action
 * 
 * @usages
 *  appStore.dispatch(updateUser({
 *      address: 'Via Sticazzi 1111',
 *      email: 'f@f.it'
 *  }));
 */
function userReducer(state = initialState, action) {

    switch(true) {

        case (action.type === STORE_RESET):

            state = {
                ...state,
                ...initialState
            };
            break;

        case (action.type === USER_UPDATE):

            state = {
                ...state,
                ...action.payload
            };
            break;

        default:
            
    }

    return state;
};

export default userReducer;